import { jsx } from 'react/jsx-runtime';
import { P as Picker } from './index-ca2214b3.js';
import dayjs from 'dayjs';
import '@rjsf/core';
import 'react-bootstrap';
import 'react';
import 'classnames';
import 'react-number-format';
import 'rc-picker';
import 'rc-picker/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import 'rc-picker/es/generate/dayjs';
import 'rc-picker/assets/index.css';
import 'styled-components';
import 'path';
import 'react-fast-compare';

function DateWidget(props) {
  const {
    value,
    onChange,
    placeholder,
    options
  } = props;
  const {
    format = 'YYYY-MM-DD',
    disabledDate
  } = options;
  return jsx(Picker, {
    showNow: true,
    disabledDate: disabledDate,
    value: value ? dayjs(value, format) : null,
    placeholder: placeholder,
    onChange: value => {
      if (value) {
        onChange(value.format(format));
      } else {
        onChange(null);
      }
    }
  });
}

export { DateWidget as default };
